var _path;
/*
 * The MIT License (MIT)
 *
 * Copyright (c) 2015 - present Instructure, Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */
import { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
class IconPeerReviewLine extends Component {
  constructor(...args) {
    super(...args);
    this.ref = null;
    this.handleRef = el => {
      const elementRef = this.props.elementRef;
      this.ref = el;
      if (typeof elementRef === 'function') {
        elementRef(el);
      }
    };
  }
  render() {
    return _jsx(SVGIcon, {
      ...this.props,
      name: "IconPeerReview",
      viewBox: "0 0 1920 1920",
      elementRef: this.handleRef,
      children: _path || (_path = _jsx("path", {
        d: "M1281.536 1465.487c-118.756 82.552-340.248 201.842-634.147 187.745-237.831-11.213-422.266-104.872-540.594-187.638v-150.9c0-128.048 81.804-238.26 194.473-261.968 113.416-23.815 229.502-37.485 344.947-40.369 146.522-3.844 295.928 9.825 441.168 40.476 112.455 23.708 194.153 133.813 194.153 261.967v150.687ZM427.179 638.576v-6.942c45.815-12.388 75.076-39.193 98.037-60.445 26.699-24.563 42.825-39.408 80.31-39.408 36.737 0 52.65 14.738 79.028 39.194 31.077 28.514 73.581 67.601 152.716 67.601 57.776 0 95.475-21.252 123.882-43.786v43.786c0 147.27-119.717 266.987-266.987 266.987-147.27 0-266.986-119.717-266.986-266.987Zm266.986-373.781c123.241 0 226.191 84.367 256.842 198.104-13.243 9.718-24.67 20.184-35.35 30.01-26.271 24.241-41.97 38.872-78.387 38.872-37.485 0-53.61-14.844-80.31-39.407-30.756-28.407-73.047-67.387-151.434-67.387-79.135 0-121.64 39.193-152.717 67.707-8.65 8.01-16.232 14.525-23.708 20.291 9.825-138.299 124.309-248.19 265.064-248.19Zm415.218 683.592c-57.028-12.067-114.804-20.825-172.58-27.873 79.669-68.562 131.144-168.842 131.144-281.938V531.781C1067.947 325.774 900.279 158 694.165 158c-206.113 0-373.781 167.774-373.781 373.781v106.795c0 112.882 51.261 212.949 130.717 281.618-57.67 6.941-115.125 16.126-171.833 28.087C117.474 982.24 0 1136.346 0 1314.693v205.26l21.68 16.019c128.794 94.94 340.995 210.812 620.69 223.948 17.194.748 34.174 1.175 50.941 1.175 317.5 0 556.08-139.154 673.234-225.123l21.786-15.913V1314.8c0-178.346-117.368-332.45-278.948-366.412Zm399.818-256.37h-120.892V571.23l225.764-225.764 120.785 120.785-225.657 225.764Zm389.48-341.85L1730.16 181.75c-27.446-27.553-75.29-27.873-103.27-.107l-324.336 324.229c-13.563 13.776-21.038 32.038-21.038 51.368v241.57h241.57c19.222 0 37.27-7.37 51.688-21.36l324.015-324.014c28.3-28.408 28.3-74.756-.107-103.27Z",
        fillRule: "evenodd"
      }))
    });
  }
}
IconPeerReviewLine.glyphName = 'peer-review';
IconPeerReviewLine.variant = 'Line';
IconPeerReviewLine.displayName = 'IconPeerReviewLine';
// eslint-disable-next-line react/forbid-foreign-prop-types
IconPeerReviewLine.propTypes = {
  ...SVGIcon.propTypes
};
IconPeerReviewLine.allowedProps = [...SVGIcon.allowedProps];
export default IconPeerReviewLine;
export { IconPeerReviewLine };